<template>
  <v-card elevation="0" style="margin-bottom:1em">
      <v-card-title>
        <div class="title">{{ $tc('title.filtro', 2) }}</div>
        <v-spacer></v-spacer>
        <v-icon @click="toggleMostrarFiltros">filter_list</v-icon>
      </v-card-title>
      <v-container fluid grid-list-md v-show="mostrarFiltros">
        <metadados-container-layout
          :ordenacao-campos="ordenacaoCampos"
          :campos-formulario="camposFormulario"
          :formulario-filtros="true"
          :ignora-obrigatorios="false"
          :layout-class="layoutClass"
          :input-layout="inputLayout"
          :objeto="filtrosGestaoProgramas"
          ref="container">
          <v-col cols="12" sm="6" md="3" slot="antes" v-if="indExibeDtAlteracao">
            <v-menu
            ref="data_alteracao"
            :close-on-content-click="false"
            v-model="menuMesAnoDtAlteracao"
            id="data_alteracao"
            name="data_alteracao"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                class="mesAnoDtAlteracao-data__text"
                :return-masked-value="true"
                v-mask="'##-####'"
                :rules="[rules.validDate]"
                v-model="dataAlteracao"
                :label="$t('label.data')"
                prepend-icon="event">
              </v-text-field>
            </template>
            <v-date-picker
              locale="pt-br"
              color="primary"
              type="month"
              v-model="filtroLogSegmentacao.dataAlteracao"
              @input="menuMesAnoDtAlteracao = false"
              ></v-date-picker>
          </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="depois" v-if="indExibeDtUltimaManutencao">
            <v-menu
            ref="data_ultima_manutencao"
            :close-on-content-click="false"
            v-model="menuMesAnoDtUltimaManutencao"
            id="data_ultima_manutencao"
            name="data_ultima_manutencao"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                class="mesAnoDtUltimaManutencao-data__text"
                :return-masked-value="true"
                v-mask="'##-####'"
                :rules="[rules.validDate]"
                v-model="dataUltimaManutencao"
                :label="$t('label.ultima_manutencao')"
                prepend-icon="event">
              </v-text-field>
            </template>
            <v-date-picker
              locale="pt-br"
              color="primary"
              type="month"
              v-model="filtroLogSegmentacao.dataUltimaManutencao"
              @input="menuMesAnoDtUltimaManutencao = false"
              ></v-date-picker>
          </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="depois" v-if="indExibeDtTreinamentoSegmentacao">
            <v-menu
            ref="data_treinamento_segmentacao"
            :close-on-content-click="false"
            v-model="menuMesAnoDtTreinamentoSegmentacao"
            id="data_treinamento_segmentacao"
            name="data_treinamento_segmentacao"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-on="on"
                class="mesAnoDtTreinamentoSegmentacao-data__text"
                :return-masked-value="true"
                v-mask="'##-####'"
                :rules="[rules.validDate]"
                v-model="dataTreinamentoSegmentacao"
                :label="$t('label.treinamento_segmentacao')"
                prepend-icon="event">
              </v-text-field>
            </template>
            <v-date-picker
              locale="pt-br"
              color="primary"
              type="month"
              v-model="filtroLogSegmentacao.dataTreinamentoSegmentacao"
              @input="menuMesAnoDtTreinamentoSegmentacao = false"
              ></v-date-picker>
          </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="3" slot="depois" v-if="indExibeAnoConclusao">
            <v-text-field
              id="ano_conclusao"
              name="ano_conclusao"
              v-model="filtroLogSegmentacao.anoConclusao"
              :label="`${$t('label.ano_conclusao')} `"
              maxlength="4"
              v-mask="'####'"
              >
            </v-text-field>
          </v-col>
        </metadados-container-layout>
      </v-container>
      <v-card-actions v-show="mostrarFiltros">
        <v-spacer></v-spacer>
        <v-btn @click="resetaFiltros"
          color="accent"
        >{{$t('label.limpar_filtros')}}</v-btn>
        <v-btn @click="aplicarFiltros"
          color="primary"
        >{{$t('label.filtrar')}}</v-btn>
      </v-card-actions>
  </v-card>
</template>

<script>
import MetadadosContainerLayout from '../../../produto/shared-components/metadados/MetadadosContainerLayout';
import { formatDateMMYYYY, parseDateYYYYMM } from '../../../produto/common/functions/date-utils';

export default {
  name: 'LogSegmentacaoFormFiltros',
  components: {
    MetadadosContainerLayout,
  },
  props: {
    ordenacaoCampos: {
      type: Array,
      default() { return []; },
    },
  },
  computed: {
    indExibeDtAlteracao() {
      return this.ordenacaoCampos.indexOf('data_alteracao') > -1;
    },
    indExibeDtUltimaManutencao() {
      return this.ordenacaoCampos.indexOf('data_ultima_manutencao') > -1;
    },
    indExibeAnoConclusao() {
      return this.ordenacaoCampos.indexOf('ano_conclusao') > -1;
    },
    indExibeDtTreinamentoSegmentacao() {
      return this.ordenacaoCampos.indexOf('data_treinamento_segmentacao') > -1;
    },
    dataAlteracao: {
      get() {
        return formatDateMMYYYY(this.filtroLogSegmentacao.dataAlteracao);
      },
      set(newValue) {
        this.filtroLogSegmentacao.dataAlteracao = parseDateYYYYMM(newValue);
      },
    },
    dataUltimaManutencao: {
      get() {
        return formatDateMMYYYY(this.filtroLogSegmentacao.dataUltimaManutencao);
      },
      set(newValue) {
        this.filtroLogSegmentacao.dataUltimaManutencao = parseDateYYYYMM(newValue);
      },
    },
    dataTreinamentoSegmentacao: {
      get() {
        return formatDateMMYYYY(this.filtroLogSegmentacao.dataTreinamentoSegmentacao);
      },
      set(newValue) {
        this.filtroLogSegmentacao.dataTreinamentoSegmentacao = parseDateYYYYMM(newValue);
      },
    },
    anoConclusao: {
      get() {
        return this.filtroLogSegmentacao.anoConclusao;
      },
      set(newValue) {
        this.filtroLogSegmentacao.anoConclusao = newValue;
      },
    },
  },
  data() {
    return {
      segmentacaoResource: this.$api.segmentacao(this.$resource),
      filtroLogSegmentacao: {
        dataAlteracao: '',
        dataUltimaManutencao: '',
        dataTreinamentoSegmentacao: '',
        anoConclusao: '',
      },
      menuMesAnoDtAlteracao: false,
      menuMesAnoDtUltimaManutencao: false,
      menuMesAnoDtTreinamentoSegmentacao: false,
      statusSegmentacao: null,
      classificacoes: null,
      tiposProjeto: null,
      tiposLoja: null,
      organizacoesProduto: null,
      estados: null,
      responsaveis: null,
      mostrarFiltros: false,
      filtrosFixados: false,
      filtrosGestaoProgramas: {},
      layoutClass: { wrap: true },
      inputLayout: {
        xs12: true,
        sm12: false,
        md12: false,
        sm6: true,
        md3: true,
        md4: false,
        md6: false,
        md9: false,
      },
      camposFormulario: {
        padrao: [
          {
            labelCampo: 'cod_cliente',
            nomCampoId: 'codCliente',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            vlrObrigatorio: false,
            async: {
              fetchFunction: (autocomplete) => this.segmentacaoResource
                .buscarClientes({ autocomplete }),
              itemValue: 'id',
              itemText: 'idExterno',
            },
          },
          {
            labelCampo: 'cliente',
            nomCampoId: 'idsCliente',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            vlrObrigatorio: false,
            async: {
              fetchFunction: (autocomplete) => this.segmentacaoResource
                .buscarClientes({ autocomplete }),
              itemValue: 'idComposto',
              itemText: 'nomCliente',
            },
          },
          {
            labelCampo: 'tipo_cliente',
            tipoCampo: 'LISTA',
            desAtributos: {
              textoItem: 'texto',
              valorItem: 'valor',
              lista: this.getListTipoCliente(),
            },
          },
          {
            labelCampo: 'atendimento_merchandising',
            tipoCampo: 'LISTA',
            desAtributos: {
              textoItem: 'texto',
              valorItem: 'valor',
              lista: this.getListaSimAndNao(),
            },
          },
          {
            labelCampo: 'segmentacao_mantida',
            tipoCampo: 'LISTA',
            desAtributos: {
              textoItem: 'texto',
              valorItem: 'valor',
              lista: this.getListaSimAndNao(),
            },
          },
          {
            labelCampo: 'programas_segmentacao',
            nomCampoId: 'descricoesSegmentacao',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.segmentacaoResource
                .buscarSegmentacaoPorDescricao({ autocomplete }),
              itemValue: 'texto',
              itemText: 'valor',
            },
          },
          {
            labelCampo: 'divisao',
            nomCampoId: 'idsDivisao',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.segmentacaoResource
                .buscarDivisaoPaiSegmentacao({ autocomplete }),
              itemValue: 'id',
              itemText: 'nome',
            },
          },
          {
            labelCampo: 'status',
            nomCampoId: 'idsStatus',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            vlrObrigatorio: false,
            async: {
              fetchFunction: () => this.getStatusSegmentacao(),
              itemValue: 'id',
              itemText: 'descricao',
            },
          },
          {
            labelCampo: 'cnpj_cpf',
            nomCampoId: 'idsDesCnpj',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            vlrObrigatorio: false,
            async: {
              fetchFunction: (autocomplete) => this.segmentacaoResource
                .buscarClientes({ autocomplete }),
              itemValue: 'idComposto',
              itemText: 'desCnpj',
            },
          },
          {
            labelCampo: 'responsavel',
            nomCampoId: 'idsResponsavel',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: () => this.getResponsavel(),
              itemValue: 'id',
              itemText: 'nome',
            },
          },
          {
            labelCampo: 'grupoeconomico',
            nomCampoId: 'idsGrupoEconomico',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.segmentacaoResource
                .buscarExtensaoSegmentacao({ autocomplete, mnemonico: 'HOLDING' }),
              itemValue: 'id',
              itemText: 'descricao',
            },
          },
          {
            labelCampo: 'customergroup',
            nomCampoId: 'idsCustomerGroup',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.segmentacaoResource
                .buscarExtensaoSegmentacao({ autocomplete, mnemonico: 'CUSTOMER_GROUP' }),
              itemValue: 'id',
              itemText: 'descricao',
            },
          },
          {
            labelCampo: 'canal',
            nomCampoId: 'idsCanal',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.segmentacaoResource
                .buscarExtensaoSegmentacao({ autocomplete, mnemonico: 'CANAL' }),
              itemValue: 'id',
              itemText: 'descricao',
            },
          },
          {
            labelCampo: 'regiao',
            nomCampoId: 'idsRegiao',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.segmentacaoResource
                .buscarRegioes({ autocomplete, ativo: true }),
              itemValue: 'id',
              itemText: 'nome',
            },
          },
          {
            labelCampo: 'estado',
            nomCampoId: 'nomEstados',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: () => this.getEstados(),
              itemValue: 'uf',
              itemText: 'nomEstado',
            },
          },
          {
            labelCampo: 'cidade',
            nomCampoId: 'idsCidade',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: (autocomplete) => this.segmentacaoResource
                .buscarCidades({ autocomplete }),
              itemValue: 'id',
              itemText: 'nomCidade',
            },
          },
          {
            labelCampo: 'classificacao_loja',
            nomCampoId: 'idClassificacaoLoja',
            tipoCampo: 'LISTA',
            async: {
              fetchFunction: () => this.getClassificacoesLoja(),
              itemValue: 'id',
              itemText: 'descricao',
            },
          },
          {
            labelCampo: 'tipo_projeto',
            nomCampoId: 'idTipoProjeto',
            tipoCampo: 'LISTA',
            async: {
              fetchFunction: () => this.getTiposPorjeto(),
              itemValue: 'id',
              itemText: 'descricao',
            },
          },
          {
            labelCampo: 'tipo_loja',
            nomCampoId: 'idsTipoLoja',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: () => this.getTiposLoja(),
              itemValue: 'id',
              itemText: 'descricao',
            },
          },
          {
            labelCampo: 'organizacao_produtos',
            nomCampoId: 'idOrganizacaoProduto',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            async: {
              fetchFunction: () => this.getOrganizacoesProduto(),
              itemValue: 'id',
              itemText: 'descricao',
            },
          },
          {
            labelCampo: 'area_total_loja',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            desAtributos: {
              textoItem: 'texto',
              valorItem: 'valor',
              lista: [
                {
                  texto: this.$tc('area_total_loja.loja_p', 1),
                  valor: 'P',
                },
                {
                  texto: this.$tc('area_total_loja.loja_m', 1),
                  valor: 'M',
                },
                {
                  texto: this.$tc('area_total_loja.loja_g', 1),
                  valor: 'G',
                },
              ],
            },
          },
          {
            labelCampo: 'area_setor_tintas',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            desAtributos: {
              textoItem: 'texto',
              valorItem: 'valor',
              lista: [
                {
                  texto: this.$tc('area_setor_tintas.ate_05', 1),
                  valor: 'area_tinta_ate_5m',
                },
                {
                  texto: this.$tc('area_setor_tintas.05_ate_50', 1),
                  valor: 'area_tinta_ate_50m',
                },
                {
                  texto: this.$tc('area_setor_tintas.50_ate_100', 1),
                  valor: 'area_tinta_ate_100m',
                },
                {
                  texto: this.$tc('area_setor_tintas.100_ate_150', 1),
                  valor: 'area_tinta_ate_150m',
                },
                {
                  texto: this.$tc('area_setor_tintas.acima_150', 1),
                  valor: 'area_tinta_maior_150m',
                },
              ],
            },
          },
          {
            labelCampo: 'investimento_acoes',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            desAtributos: {
              textoItem: 'texto',
              valorItem: 'valor',
              lista: this.getInvestimentoAcao(),
            },
          },
          {
            labelCampo: 'investimento_cliente',
            tipoCampo: 'LISTA',
            desAtributos: {
              textoItem: 'texto',
              valorItem: 'valor',
              lista: this.getListaSimAndNao(),
            },
          },
          {
            labelCampo: 'investimento_outros',
            tipoCampo: 'LISTA',
            desAtributos: {
              textoItem: 'texto',
              valorItem: 'valor',
              lista: this.getListaSimAndNao(),
            },
          },
          {
            labelCampo: 'investimento_total',
            tipoCampo: 'MULTIPLA_ESCOLHA',
            desAtributos: {
              textoItem: 'texto',
              valorItem: 'valor',
              lista: this.getInvestimentoTotal(),
            },
          },
          {
            labelCampo: 'treinamento_segmentacao',
            tipoCampo: 'LISTA',
            desAtributos: {
              textoItem: 'texto',
              valorItem: 'valor',
              lista: [
                {
                  texto: this.$tc('treinamento_segmentacao.realizado', 1),
                  valor: 'REALIZADO',
                },
                {
                  texto: this.$tc('treinamento_segmentacao.nao_realizado', 1),
                  valor: 'NAO_REALIZADO',
                },
              ],
            },
          },
          {
            labelCampo: 'virada_loja',
            tipoCampo: 'DATA',
          },
        ],
      },
      rules: {
        validDate: (value) => this.isDataValida(value) || this.$t('message.data_invalida'),
      },
    };
  },
  methods: {
    resetaFiltros() {
      this.filtrosGestaoProgramas = {};
      this.dataAlteracao = null;
      this.dataUltimaManutencao = null;
      this.dataTreinamentoSegmentacao = null;
      this.anoConclusao = null;
      this.$emit('LogSegmentacaoFormFiltros__ResetaFiltros');
    },
    aplicarFiltros() {
      const params = this.formatarParams();
      this.$emit('LogSegmentacaoFormFiltros__AplicaFiltros', params);
    },
    formatarParams() {
      const params = {
        ...this.$refs.container.getValoresCamposPadrao(),
      };

      if (this.dataAlteracao) {
        params.dataAlteracao = this.dataAlteracao;
      }

      if (this.dataUltimaManutencao) {
        params.dataUltimaManutencao = this.dataUltimaManutencao;
      }

      if (this.anoConclusao) {
        params.anoConclusao = this.anoConclusao;
      }

      if (this.dataTreinamentoSegmentacao) {
        params.dataTreinamentoSegmentacao = this.dataTreinamentoSegmentacao;
      }

      let idsCompostoCliente = [];

      console.log(params.idsDesCnpj);
      if (params.idsDesCnpj) {
        idsCompostoCliente = this.getIdsCliente(idsCompostoCliente, params.idsDesCnpj);
        delete params.idsDesCnpj;
      }

      if (idsCompostoCliente && idsCompostoCliente.length > 0) {
        params.idsCompostoCliente = idsCompostoCliente;
      }

      return params;
    },
    getIdsCliente(arrayParams, array) {
      array.forEach((v) => {
        if (!arrayParams.includes(v)) {
          arrayParams.push(v);
        }
      });
      return arrayParams;
    },
    toggleMostrarFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },
    getListaSimAndNao() {
      return [
        {
          texto: this.$tc('label.sim', 1),
          valor: 'true',
        },
        {
          texto: this.$tc('label.nao', 1),
          valor: 'false',
        },
      ];
    },
    getListTipoCliente() {
      return [
        {
          texto: this.$tc('label.cliente', 1),
          valor: 'true',
        },
        {
          texto: this.$tc('label.cliente_pequeno_porte', 1),
          valor: 'false',
        },
      ];
    },
    getInvestimentoTotal() {
      return [
        {
          texto: this.$tc('lista_ranges_investimento.1000', 1),
          valor: 'investimento_total_ate_1000',
        },
        {
          texto: this.$tc('lista_ranges_investimento.1000_ate_5000', 1),
          valor: 'investimento_total_ate_5000',
        },
        {
          texto: this.$tc('lista_ranges_investimento.5000_ate_20000', 1),
          valor: 'investimento_total_ate_20000',
        },
        {
          texto: this.$tc('lista_ranges_investimento.20000_ate_40000', 1),
          valor: 'investimento_total_ate_40000',
        },
        {
          texto: this.$tc('lista_ranges_investimento.acima_40000', 1),
          valor: 'investimento_total_maior_40000',
        },
      ];
    },
    getInvestimentoAcao() {
      return [
        {
          texto: this.$tc('lista_ranges_investimento.1000', 1),
          valor: 'investimento_acoes_ate_1000',
        },
        {
          texto: this.$tc('lista_ranges_investimento.1000_ate_5000', 1),
          valor: 'investimento_acoes_ate_5000',
        },
        {
          texto: this.$tc('lista_ranges_investimento.5000_ate_20000', 1),
          valor: 'investimento_acoes_ate_20000',
        },
        {
          texto: this.$tc('lista_ranges_investimento.20000_ate_40000', 1),
          valor: 'investimento_acoes_ate_40000',
        },
        {
          texto: this.$tc('lista_ranges_investimento.acima_40000', 1),
          valor: 'investimento_acoes_maior_40000',
        },
      ];
    },
    getResponsavel() {
      return this.responsaveis;
    },
    getStatusSegmentacao() {
      return this.statusSegmentacao;
    },
    getEstados() {
      return this.estados;
    },
    getClassificacoesLoja() {
      return this.classificacoes;
    },
    getTiposPorjeto() {
      return this.tiposProjeto;
    },
    getTiposLoja() {
      return this.tiposLoja;
    },
    getOrganizacoesProduto() {
      return this.organizacoesProduto;
    },
    isDataValida(value) {
      return (!value || (value.length === 7 && this.moment(value, 'MM-YYYY').isValid()));
    },
  },
  beforeMount() {
    this.statusSegmentacao = this.segmentacaoResource.buscarStatusSegmentacao();
    this.estados = this.segmentacaoResource.buscarEstados();
    this.classificacoes = this.segmentacaoResource.buscarClassificacoesLoja();
    this.tiposProjeto = this.segmentacaoResource.buscarTiposProjeto();
    this.tiposLoja = this.segmentacaoResource.buscarTiposLoja();
    this.organizacoesProduto = this.segmentacaoResource.buscarOrganizacaoProdutos();
    this.responsaveis = this.segmentacaoResource.buscarResponsavel();
  },
};
</script>
